import { render, staticRenderFns } from "./CommonSetting.vue?vue&type=template&id=268ff4a5&scoped=true"
import script from "./CommonSetting.vue?vue&type=script&lang=js"
export * from "./CommonSetting.vue?vue&type=script&lang=js"
import style0 from "./CommonSetting.vue?vue&type=style&index=0&id=268ff4a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ff4a5",
  null
  
)

export default component.exports